// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1MI8A","clinicsSelect":"TableHeading_clinicsSelect__1tNNa"};